// Base URL - update this to your actual base path
const BASE_URL = import.meta.env.VITE_IMAGEKIT_URL;

export const ANDAR_BAHAR_CARDS = {
  0: `${BASE_URL}/andar-bahar-cards/0.jpg`,
  1: `${BASE_URL}/andar-bahar-cards/1.jpg`,
  2: `${BASE_URL}/andar-bahar-cards/2.jpg`,
  3: `${BASE_URL}/andar-bahar-cards/3.jpg`,
  4: `${BASE_URL}/andar-bahar-cards/4.jpg`,
  5: `${BASE_URL}/andar-bahar-cards/5.jpg`,
  6: `${BASE_URL}/andar-bahar-cards/6.jpg`,
  7: `${BASE_URL}/andar-bahar-cards/7.jpg`,
  8: `${BASE_URL}/andar-bahar-cards/8.jpg`,
  9: `${BASE_URL}/andar-bahar-cards/9.jpg`,
  10: `${BASE_URL}/andar-bahar-cards/10.jpg`,
  11: `${BASE_URL}/andar-bahar-cards/11.jpg`,
  12: `${BASE_URL}/andar-bahar-cards/12.jpg`,
  13: `${BASE_URL}/andar-bahar-cards/13.jpg`,
};

export const CARDS_SINGLE = {
  10: `${BASE_URL}/cards/single/10.jpg`,
  2: `${BASE_URL}/cards/single/2.jpg`,
  3: `${BASE_URL}/cards/single/3.jpg`,
  4: `${BASE_URL}/cards/single/4.jpg`,
  5: `${BASE_URL}/cards/single/5.jpg`,
  6: `${BASE_URL}/cards/single/6.jpg`,
  7: `${BASE_URL}/cards/single/7.jpg`,
  8: `${BASE_URL}/cards/single/8.jpg`,
  9: `${BASE_URL}/cards/single/9.jpg`,
  A: `${BASE_URL}/cards/single/A.jpg`,
  J: `${BASE_URL}/cards/single/J.jpg`,
  K: `${BASE_URL}/cards/single/K.jpg`,
  Q: `${BASE_URL}/cards/single/Q.jpg`,
};

export const CARDS = {
  1: `${BASE_URL}/cards/1.jpg`,
  10: `${BASE_URL}/cards/10.png`,
  '10CC': `${BASE_URL}/cards/10CC.jpg`,
  '10DD': `${BASE_URL}/cards/10DD.jpg`,
  '10HH': `${BASE_URL}/cards/10HH.jpg`,
  '10SS': `${BASE_URL}/cards/10SS.jpg`,
  2: `${BASE_URL}/cards/2.png`,
  '2CC': `${BASE_URL}/cards/2CC.jpg`,
  '2DD': `${BASE_URL}/cards/2DD.jpg`,
  '2HH': `${BASE_URL}/cards/2HH.jpg`,
  '2SS': `${BASE_URL}/cards/2SS.jpg`,
  3: `${BASE_URL}/cards/3.png`,
  '3CC': `${BASE_URL}/cards/3CC.jpg`,
  '3DD': `${BASE_URL}/cards/3DD.jpg`,
  '3HH': `${BASE_URL}/cards/3HH.jpg`,
  '3SS': `${BASE_URL}/cards/3SS.jpg`,
  4: `${BASE_URL}/cards/4.png`,
  '4CC': `${BASE_URL}/cards/4CC.jpg`,
  '4DD': `${BASE_URL}/cards/4DD.jpg`,
  '4HH': `${BASE_URL}/cards/4HH.jpg`,
  '4SS': `${BASE_URL}/cards/4SS.jpg`,
  5: `${BASE_URL}/cards/5.png`,
  '5CC': `${BASE_URL}/cards/5CC.jpg`,
  '5DD': `${BASE_URL}/cards/5DD.jpg`,
  '5HH': `${BASE_URL}/cards/5HH.jpg`,
  '5SS': `${BASE_URL}/cards/5SS.jpg`,
  6: `${BASE_URL}/cards/6.png`,
  '6CC': `${BASE_URL}/cards/6CC.jpg`,
  '6DD': `${BASE_URL}/cards/6DD.jpg`,
  '6HH': `${BASE_URL}/cards/6HH.jpg`,
  '6SS': `${BASE_URL}/cards/6SS.jpg`,
  7: `${BASE_URL}/cards/7.png`,
  '7CC': `${BASE_URL}/cards/7CC.jpg`,
  '7DD': `${BASE_URL}/cards/7DD.jpg`,
  '7HH': `${BASE_URL}/cards/7HH.jpg`,
  '7SS': `${BASE_URL}/cards/7SS.jpg`,
  8: `${BASE_URL}/cards/8.png`,
  '8CC': `${BASE_URL}/cards/8CC.jpg`,
  '8DD': `${BASE_URL}/cards/8DD.jpg`,
  '8HH': `${BASE_URL}/cards/8HH.jpg`,
  '8SS': `${BASE_URL}/cards/8SS.jpg`,
  9: `${BASE_URL}/cards/9.png`,
  '9CC': `${BASE_URL}/cards/9CC.jpg`,
  '9DD': `${BASE_URL}/cards/9DD.jpg`,
  '9HH': `${BASE_URL}/cards/9HH.jpg`,
  '9SS': `${BASE_URL}/cards/9SS.jpg`,
  A: `${BASE_URL}/cards/A.png`,
  ACC: `${BASE_URL}/cards/ACC.jpg`,
  ADD: `${BASE_URL}/cards/ADD.jpg`,
  AHH: `${BASE_URL}/cards/AHH.jpg`,
  ASS: `${BASE_URL}/cards/ASS.jpg`,
  J: `${BASE_URL}/cards/J.png`,
  JCC: `${BASE_URL}/cards/JCC.jpg`,
  JDD: `${BASE_URL}/cards/JDD.jpg`,
  JHH: `${BASE_URL}/cards/JHH.jpg`,
  JSS: `${BASE_URL}/cards/JSS.jpg`,
  K: `${BASE_URL}/cards/K.png`,
  KCC: `${BASE_URL}/cards/KCC.jpg`,
  KDD: `${BASE_URL}/cards/KDD.jpg`,
  KHH: `${BASE_URL}/cards/KHH.jpg`,
  KSS: `${BASE_URL}/cards/KSS.jpg`,
  Q: `${BASE_URL}/cards/Q.png`,
  QCC: `${BASE_URL}/cards/QCC.jpg`,
  QDD: `${BASE_URL}/cards/QDD.jpg`,
  QHH: `${BASE_URL}/cards/QHH.jpg`,
  QSS: `${BASE_URL}/cards/QSS.jpg`,
};

export const JOKER1 = {
  1: `${BASE_URL}/joker1/1.png`,
  2: `${BASE_URL}/joker1/2.png`,
  3: `${BASE_URL}/joker1/3.png`,
  4: `${BASE_URL}/joker1/4.png`,
  5: `${BASE_URL}/joker1/5.png`,
  6: `${BASE_URL}/joker1/6.png`,
  7: `${BASE_URL}/joker1/7.png`,
  8: `${BASE_URL}/joker1/8.png`,
  9: `${BASE_URL}/joker1/9.png`,
  10: `${BASE_URL}/joker1/10.png`,
  11: `${BASE_URL}/joker1/11.png`,
  12: `${BASE_URL}/joker1/12.png`,
  13: `${BASE_URL}/joker1/13.png`,
  14: `${BASE_URL}/joker1/14.png`,
};

export const BALLS = {
  'ball-blank': `${BASE_URL}/balls/ball-blank.png`,
};

export const CRICKET = {
  ball0: `${BASE_URL}/cricket/ball0.png`,
  ball1: `${BASE_URL}/cricket/ball1.png`,
  ball10: `${BASE_URL}/cricket/ball10.png`,
  ball2: `${BASE_URL}/cricket/ball2.png`,
  ball3: `${BASE_URL}/cricket/ball3.png`,
  ball4: `${BASE_URL}/cricket/ball4.png`,
  ball5: `${BASE_URL}/cricket/ball5.png`,
  ball6: `${BASE_URL}/cricket/ball6.png`,
  ball7: `${BASE_URL}/cricket/ball7.png`,
  ball8: `${BASE_URL}/cricket/ball8.png`,
  ball9: `${BASE_URL}/cricket/ball9.png`,
};

export const DICE = {
  dice1: `${BASE_URL}/dice/dice1.png`,
  dice2: `${BASE_URL}/dice/dice2.png`,
  dice3: `${BASE_URL}/dice/dice3.png`,
  dice4: `${BASE_URL}/dice/dice4.png`,
  dice5: `${BASE_URL}/dice/dice5.png`,
  dice6: `${BASE_URL}/dice/dice6.png`,
};

export const DOLIDANA = {
  dice1: `${BASE_URL}/dolidana/dice1.png`,
  dice2: `${BASE_URL}/dolidana/dice2.png`,
  dice3: `${BASE_URL}/dolidana/dice3.png`,
  dice4: `${BASE_URL}/dolidana/dice4.png`,
  dice5: `${BASE_URL}/dolidana/dice5.png`,
  dice6: `${BASE_URL}/dolidana/dice6.png`,
};

export const GAMES_DEFAULT = {
  default: `${BASE_URL}/games/default.jpg`,
};

export const ICONS = {
  club: `${BASE_URL}/icons/club.png`,
  diamond: `${BASE_URL}/icons/diamond.png`,
  heart: `${BASE_URL}/icons/heart.png`,
  lock: `${BASE_URL}/icons/lock.svg`,
  spade: `${BASE_URL}/icons/spade.png`,
};

export const ICONS_PUBLIC = {
  lock: `/images/lock.svg`,
  info: `/images/info.svg`,
  spinner: '/images/spinner.svg',
  chipBg: `/images/chipBg.svg`,
  trophy: `/images/trophy.svg`,
  handDown: `/images/handDown.svg`,
};

export const SEQUENCE = {
  s1Icon: `${BASE_URL}/sequence/s1-icon.png`,
  s2Icon: `${BASE_URL}/sequence/s2-icon.png`,
  s3Icon: `${BASE_URL}/sequence/s3-icon.png`,
  s4Icon: `${BASE_URL}/sequence/s4-icon.png`,
  s5Icon: `${BASE_URL}/sequence/s5-icon.png`,
  s6Icon: `${BASE_URL}/sequence/s6-icon.png`,
  s1: `${BASE_URL}/sequence/s1.png`,
  s2: `${BASE_URL}/sequence/s2.png`,
  s3: `${BASE_URL}/sequence/s3.png`,
  s4: `${BASE_URL}/sequence/s4.png`,
  s5: `${BASE_URL}/sequence/s5.png`,
  s6: `${BASE_URL}/sequence/s6.png`,
};

export const LOTTERY = {
  ball0: `${BASE_URL}/lottery/ball0.png`,
  ball1: `${BASE_URL}/lottery/ball1.png`,
  ball2: `${BASE_URL}/lottery/ball2.png`,
  ball3: `${BASE_URL}/lottery/ball3.png`,
  ball4: `${BASE_URL}/lottery/ball4.png`,
  ball5: `${BASE_URL}/lottery/ball5.png`,
  ball6: `${BASE_URL}/lottery/ball6.png`,
  ball7: `${BASE_URL}/lottery/ball7.png`,
  ball8: `${BASE_URL}/lottery/ball8.png`,
  ball9: `${BASE_URL}/lottery/ball9.png`,
};

export const ROULETTE = {
  '00': `${BASE_URL}/roulette/00.png`,
  '01': `${BASE_URL}/roulette/01.png`,
  '02': `${BASE_URL}/roulette/02.png`,
  '03': `${BASE_URL}/roulette/03.png`,
  '04': `${BASE_URL}/roulette/04.png`,
  '05': `${BASE_URL}/roulette/05.png`,
  '06': `${BASE_URL}/roulette/06.png`,
  '07': `${BASE_URL}/roulette/07.png`,
  '08': `${BASE_URL}/roulette/08.png`,
  '09': `${BASE_URL}/roulette/09.png`,
  '10': `${BASE_URL}/roulette/10.png`,
  '11': `${BASE_URL}/roulette/11.png`,
  '12': `${BASE_URL}/roulette/12.png`,
  '13': `${BASE_URL}/roulette/13.png`,
  '14': `${BASE_URL}/roulette/14.png`,
  '15': `${BASE_URL}/roulette/15.png`,
  '16': `${BASE_URL}/roulette/16.png`,
  '17': `${BASE_URL}/roulette/17.png`,
  '18': `${BASE_URL}/roulette/18.png`,
  '19': `${BASE_URL}/roulette/19.png`,
  '20': `${BASE_URL}/roulette/20.png`,
  '21': `${BASE_URL}/roulette/21.png`,
  '22': `${BASE_URL}/roulette/22.png`,
  '23': `${BASE_URL}/roulette/23.png`,
  '24': `${BASE_URL}/roulette/24.png`,
  '25': `${BASE_URL}/roulette/25.png`,
  '26': `${BASE_URL}/roulette/26.png`,
  '27': `${BASE_URL}/roulette/27.png`,
  '28': `${BASE_URL}/roulette/28.png`,
  '29': `${BASE_URL}/roulette/29.png`,
  '30': `${BASE_URL}/roulette/30.png`,
  '31': `${BASE_URL}/roulette/31.png`,
  '32': `${BASE_URL}/roulette/32.png`,
  '33': `${BASE_URL}/roulette/33.png`,
  '34': `${BASE_URL}/roulette/34.png`,
  '35': `${BASE_URL}/roulette/35.png`,
  '36': `${BASE_URL}/roulette/36.png`,
  icon: `${BASE_URL}/roulette/icon.svg`,
};

export const SUPEROVER_BALLS = {
  '10': `${BASE_URL}/superover/balls/10.png`,
  '2': `${BASE_URL}/superover/balls/2.png`,
  '3': `${BASE_URL}/superover/balls/3.png`,
  '4': `${BASE_URL}/superover/balls/4.png`,
  '6': `${BASE_URL}/superover/balls/6.png`,
  A: `${BASE_URL}/superover/balls/A.png`,
  ball0: `${BASE_URL}/superover/balls/ball0.png`,
  ball1: `${BASE_URL}/superover/balls/ball1.png`,
  ball2: `${BASE_URL}/superover/balls/ball2.png`,
  ball3: `${BASE_URL}/superover/balls/ball3.png`,
  ball4: `${BASE_URL}/superover/balls/ball4.png`,
  ball6: `${BASE_URL}/superover/balls/ball6.png`,
  K: `${BASE_URL}/superover/balls/K.png`,
  wicket: `${BASE_URL}/superover/balls/wicket.png`,
};

export const SUPEROVER_CARDS = {
  card10: `${BASE_URL}/superover/cards/card10.png`,
  card2: `${BASE_URL}/superover/cards/card2.png`,
  card3: `${BASE_URL}/superover/cards/card3.png`,
  card4: `${BASE_URL}/superover/cards/card4.png`,
  card6: `${BASE_URL}/superover/cards/card6.png`,
  cardA: `${BASE_URL}/superover/cards/cardA.png`,
  cardK: `${BASE_URL}/superover/cards/cardK.png`,
};

export const VIRTUAL_CASINO = {
  lucky9: `${BASE_URL}/virtual-casino/lucky9.png`,
  table_bg: `${BASE_URL}/virtual-casino/table-bg.jpg`,
  vaaa: `${BASE_URL}/virtual-casino/vaaa.png`,
  vbtable: `${BASE_URL}/virtual-casino/vbtable.png`,
  vdt6: `${BASE_URL}/virtual-casino/vdt6.png`,
  vdtl20: `${BASE_URL}/virtual-casino/vdtl20.png`,
  vlucky7: `${BASE_URL}/virtual-casino/vlucky7.png`,
  vteen: `${BASE_URL}/virtual-casino/vteen.png`,
  vteen20: `${BASE_URL}/virtual-casino/vteen20.png`,
  vteenmuf: `${BASE_URL}/virtual-casino/vteenmuf.png`,
  vtrio: `${BASE_URL}/virtual-casino/vtrio.png`,
};

export const ROOT_ASSETS = {
  clock: `${BASE_URL}/clock.png`,
  cricket20bg: `${BASE_URL}/cricket20bg.jpg`,
  fight: `${BASE_URL}/fight.png`,
  lucky9: `${BASE_URL}/lucky9.png`,
  score_bg: `${BASE_URL}/score-bg.png`,
  scorecard_bg: `${BASE_URL}/scorecard-bg.png`,
  soccer_ball: `${BASE_URL}/soccer-ball.png`,
  trap13: `${BASE_URL}/trap13.png`,
  trap14: `${BASE_URL}/trap14.png`,
  trap15: `${BASE_URL}/trap15.png`,
  trape_seven: `${BASE_URL}/trape-seven.png`,
  winner: `${BASE_URL}/winner.png`,
};

export const RULES = {
  dt20: `${BASE_URL}/Rules/dt202.jpg`,
  dt6: `${BASE_URL}/Rules/dt6.jpg`,
  poker: `${BASE_URL}/Rules/poker.jpg`,
  race20: `${BASE_URL}/Rules/race20.jpg`,
  mogamboImg1: `${BASE_URL}/Rules/mogambo/img1.jpg`,
  teen20b: `${BASE_URL}/Rules/teen20b.jpg`,
  teen6: `${BASE_URL}/Rules/teen6.jpg`,
  joker1: `${BASE_URL}/Rules/joker1.jpg`,
  joker2: `${BASE_URL}/Rules/joker2.jpg`,
  joker3: `${BASE_URL}/Rules/joker3.jpg`,
  superover: `${BASE_URL}/Rules/superover.jpg`,
  cricketv3: `${BASE_URL}/Rules/cricketv3.jpg`,
};

export const IMAGES = {
  BALLS,
  CARDS,
  CARDS_SINGLE,
  ANDAR_BAHAR_CARDS,
  JOKER1,
  CRICKET,
  DICE,
  DOLIDANA,
  GAMES_DEFAULT,
  ICONS,
  ICONS_PUBLIC,
  SEQUENCE,
  LOTTERY,
  ROULETTE,
  SUPEROVER_BALLS,
  SUPEROVER_CARDS,
  VIRTUAL_CASINO,
  ROOT_ASSETS,
  RULES,
};
